import { Box, Container, Grid, GridItem, Heading, Link, List, Stack, Text } from "@chakra-ui/react";
import { CheckCircleIcon } from "@phosphor-icons/react/dist/ssr";
import Head from "next/head";

import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";

const TerminosCondicionesGuiaRent = () => {
    return (
        <Container maxWidth="100vw" pt={24} px={{ base: 4, lg: 20 }}>
            <Header />
            <Head>
                <title>Terminos y Condiciones Guia Rent | Grupo Guía</title>
            </Head>
            <Grid templateColumns="repeat(4, 1fr)" gap={6}>
                <GridItem colSpan={1} display={{ base: "none", md: "block" }} fontSize="16px">
                    <Stack mt="28" mb={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones"
                        >
                            Terminos y condiciones Contratación del portal
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            href="/terminosycondiciones-guiabroker"
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                        >
                            Terminos y condiciones Guía broker
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3} borderLeftColor="#17669D" borderLeftWidth="3px">
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-guiarent"
                        >
                            Terminos y condiciones Guía Rent
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/politicanodiscriminacion"
                        >
                            Política de no discriminación
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/cartaderechosconsumidor"
                        >
                            Carta de derechos del consumidor
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-guiaconnect"
                        >
                            Términos y condiciones Guia Connect
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-soyinmobiliaria"
                        >
                            Terminos y condiciones Soy Inmobiliaria
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-pagocomprasonline"
                        >
                            Términos y Condiciones para la Selección de Forma de Pago en Compras en
                            Línea
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-alianzas"
                        >
                            Términos y Condiciones - Guía Alianzas
                        </Link>
                    </Stack>
                </GridItem>
                <GridItem colSpan={{ base: 4, md: 3 }}>
                    <Box mb="4" mt="24">
                        <Heading
                            as="h1"
                            fontSize={{ md: "4xl", base: "2xl" }}
                            textAlign="center"
                            mb="8"
                            color="accent.500"
                            fontWeight="bold"
                        >
                            Términos y Condiciones Generales GUIA RENT
                        </Heading>
                    </Box>
                    <Box lineHeight="2" mb="8">
                        <Text>
                            Este contrato contiene los derechos y obligaciones de las partes{" "}
                            <strong>
                                {`(indistintamente, los "Términos y Condiciones Generales GUIA y/o las
                                    "Condiciones")`}
                            </strong>{" "}
                            aplicables al uso de los servicios mismos, ofrecidos por{" "}
                            <strong>GUIA EXCELENCIA INMOBILIARIA S.A. DE C.V.</strong>
                            {` ("GUIA")`}, dentro del sitio www.grupoguia.mx.{` ("Sitio Web")`}.
                            <br /> <br />
                            Cualquier persona que desee acceder y/o usar el sitio o los servicios
                            podrá hacerlo sujetándose a las condiciones junto con todas las demás
                            políticas y principios que rigen GUIA RENT y que son incorporados al
                            presente por referencia.
                            <br /> <br />
                            El Usuario debe leer, entender y aceptar todas las condiciones
                            establecidas en los Términos y Condiciones Generales{" "}
                            <strong>GUIA</strong> y el Aviso de Privacidad, establecidos en nuestro
                            Sitio Web, así como en los demás documentos incorporados a los mismos
                            por referencia, previo a su inscripción como Usuario de{" "}
                            <strong>GUIA</strong>.
                            <br /> <br />
                            <strong>GUIA</strong> ofrece una plataforma por Internet cuya función es
                            conectar a Arrendatarios que tienen un requerimiento para Arrendar un
                            inmueble, con las propiedades disponibles publicitadas, así como para
                            transferir el servicio de cobranza de renta a través de un tercero
                            denominado CLUB DE RENTAS LMS S.A.P.I. de C.V. (en lo sucesivo HAMOC) y
                            sujeto a las Condiciones de Uso de HAMOC. Tales servicios se pueden
                            consultar en el sitio www.grupoguia.mx/guiarent.
                            <br /> <br />
                            Le pedimos lea estos términos y condiciones generales de GUIA RENT
                            detenidamente, puesto que contienen información importante relativa a
                            sus derechos, recursos y obligaciones jurídicos, incluyendo varias
                            limitaciones y exclusiones respecto a la responsabilidad de GUIA RENT,
                            cláusulas que rigen la jurisdicción y competencia en materia de
                            resolución de conflictos y obligaciones de cumplimiento de la
                            legislación aplicable.
                        </Text>
                    </Box>
                    <Box lineHeight="2" mb="12">
                        <Heading
                            as="h2"
                            mb="6"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            1. OBJETO
                        </Heading>
                        <Text mb={8}>
                            El sitio web de GUIA EXCELENCIA INMOBILIARIA S.A. DE C.V. (en lo
                            sucesivo GUIA) se encuentra disponible para usted en los términos y
                            condiciones que se describen en este sitio web, mismos que puede aceptar
                            sin hacer modificación alguna.
                            <br /> <br />
                            GUIA podrá variar, en cualquier momento, los términos y condiciones aquí
                            descritos. Cuando dichas modificaciones, por legislación aplicable,
                            impliquen realizarle notificación y esto sea posible, usted recibirá
                            dicho aviso.
                            <br /> <br />
                            El contenido de este sitio web está pensado en usted, para que conozca y
                            se beneficie de los servicios de GUIA. No se encuentra permitido el uso
                            de este sitio web para fines distintos de los ofrecidos, por lo que
                            deberá abstenerse de reproducir de manera total o parcial, por cualquier
                            medio, lo que aquí se presenta.
                            <br /> <br />
                            Si usted no se encuentra de acuerdo en estos términos y condiciones, en
                            forma completa y absoluta, deberá usted evitar el acceso, uso y en
                            general observar el sitio web. Al acceder, usar, observar y en general
                            tener contacto con este sitio se entenderá que usted consiente y acepta
                            de manera absoluta lo aquí estipulado.
                            <br /> <br />
                            Es importante usted conozca que GUIA no guardará una copia
                            individualizada del presente convenio celebrado con usted, salvo que
                            usted lo solicite por escrito acudiendo directamente a la dirección Av.
                            Pablo Neruda #2813, Col. Providencia 4ta sección, C.P. 44639,
                            Guadalajara, Jalisco.
                            <br /> <br />
                            GUIA no tiene vinculación a sitios web de terceros con los que no tenga
                            una relación jurídica en términos de la legislación aplicable para
                            cumplir con los servicios ofrecidos a usted y deslinda los presentes
                            términos y condiciones a cualquier contenido en el sitio de dichos
                            terceros.
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            2. ACCESO
                        </Heading>
                        <Text mb={8}>
                            {`Para tener acceso a los servicios del sitio web, el usuario deberá crear
                                un nombre de usuario y una contraseña. El usuario será el único y
                                exclusivo responsable por la confidencialidad de su identidad digital.
                                En caso de pérdida de usuario y/o contraseña el usuario podrá recuperar
                                su información en el botón de "Recuperar Contraseña", en caso de robo o
                                vulneración de su nombre de usuario y/o contraseña deberá comunicarlo a
                                GUIA, a la brevedad, en la sección de "Soporte Técnico" ubicado en el
                                footer del Home del sitio https://www.grupoguia.mx/ con independencia de
                                las medidas de seguridad que pudiera corresponderle, ante cualquier
                                inconformidad acerca del servicio de la plataforma usted podrá presentar
                                su inconformidad a través de la herramienta ayúdanos a ser mejor o
                                enviando un email al correo atencionaclientes@grupoguia.mx mismo que se
                                encuentra habilitado para responder en días y horas y hábiles.`}
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            3. OFERTAS DE EMPLEO
                        </Heading>
                        <Text mb={8}>
                            GUIA no oferta empleo a través de este sitio web por lo que se deslinda
                            de cualquier responsabilidad por el uso indebido de un tercero. Si usted
                            desea colaborar con nosotros, se le recomienda llamar a nuestros números
                            oficiales de teléfono, que se encuentran en el contenido del sitio web,
                            para efecto de solicitar información respecto a las vacantes y formas de
                            enviar su información.
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            4. PRODUCTOS Y SERVICIOS
                        </Heading>
                        <Text mb={8}>
                            La información que GUIA proporciona al usuario sobre los productos
                            ofertados por GUIA RENT son con carácter informativo y orientativo. Si
                            tiene el usuario cualquier duda específica sobre las dimensiones,
                            cualidades, características y especificaciones de los mismos, podrá
                            dejar sus datos para ser contactado por un asesor de ventas autorizado
                            por GUIA EXCELENCIA INMOBILIARIA S.A. DE C.V. o en su defecto llamar al
                            número de contacto que aparece en la publicación de la propiedad en
                            específico.
                            <br /> <br />
                            Los presentes términos y condiciones son aplicables a las relaciones que
                            se deriven del actuar de los promotores autorizados, con los
                            Propietarios y posibles Inquilinos, a través del servicio que presta
                            GUIA.
                            <br /> <br />
                            GUIA se limita a proveer la Plataforma que facilita la interacción entre
                            el Propietario y los posibles inquilinos.
                            <br /> <br />
                            Por un lado, el Propietario accede y registra el o los inmuebles que
                            desea arrendar y/o comprar y se le asigna un Promotor Autorizado por
                            GUIA quien se encargará de dar seguimiento a su expediente, hacer
                            sugerencias, atender dudas y en momento poder acudir al inmueble para
                            recabar fotografías del inmueble únicamente con fines de promoción, para
                            que dé está manera el promotor pueda realizar una atención personalizada
                            y la consecución de posibles Inquilinos, así como llevar a cabo visitas
                            guiadas a los inmuebles y cualquier otra acción necesaria para lograr
                            que el posible Inquilino haga la oferta de renta, el Promotor Autorizado
                            actúa como un facilitador de la consecución de posibles Inquilinos y a
                            su vez podrá conseguir clientes interesados en los servicios de GUIA.
                            <br /> <br />
                            GUIA para mantener la integridad y la calidad de sus servicios de manera
                            constante otorga mantenimiento y realiza actualizaciones a su
                            Plataforma, a través de la cual se realiza la divulgación,
                            arrendamientos inmobiliarios y/o promoción para el arrendamiento de
                            inmuebles cuyo acceso es a través de la misma Plataforma.
                            <br /> <br />
                            Todos los precios y tarifas presentadas en la página web de GUIA estarán
                            sujetos a disponibilidad, cambios y vigencia, por lo que se recomienda
                            visitar constantemente este sitio. Aplicarán restricciones y condiciones
                            para cada tarifa publicada según su disponibilidad y demás
                            particularidades de la oferta. GUIA no se hace responsable por nada
                            relacionado con las cantidades publicadas o pactadas por el propietario,
                            ofertante y en general cualquier persona que participe en le proceso de
                            renta ajeno a GUIA.
                            <br /> <br />
                            El Propietario declara que: (i) es el legítimo propietario, y que cuenta
                            con el pleno uso y goce del inmueble respectivo; (ii) que no existe
                            impedimento y/o restricción legal, contractual, corporativo o de
                            cualquier índole para la celebración de un contrato de arrendamiento;
                            (iii) no hay reclamación, demanda o procedimiento judicial o
                            extrajudicial alguno relacionado con el inmueble, ni existe
                            procedimiento judicial o administrativo de embargo, expropiación o
                            extinción de dominio que pueda afectar la legítima propiedad por parte
                            del Propietario sobre el inmueble o la legalidad y validez de los
                            derechos que detenten los posibles Inquilinos y Compradores, según sea
                            el caso; (iv) el inmueble respetivo: (a) se encuentra libre de carga o
                            gravamen, o cualquier otra limitación de dominio que impida la
                            celebración de los contratos de arrendamiento, (b)que se encuentra al
                            día con todos los impuestos aplicables, así como con las cuotas de
                            mantenimiento y del condominio (en su caso), y con todos los gastos por
                            servicios de agua, luz, teléfono, internet, y gas, en términos de las
                            leyes aplicables en México.
                            <br /> <br />
                            El Propietario reconoce y acepta que toda la búsqueda de posibles
                            Inquilinos y Compradores se hará por intermedio de GUIA y/o terceros que
                            este disponga para tal fin, como es el caso de HAMOC, por lo que el
                            Propietario se obliga a no interactuar de manera directa con el posible
                            Inquilino o Comprador previo a la consumación de la firma del contrato
                            de arrendamiento.
                            <br /> <br />
                            El propietario accederá y presentará toda la información relacionada con
                            el inmueble únicamente por medio de la plataforma, no se recibirá
                            información adicional por alguna otra vía. GUIA no es ni será
                            responsable del estado físico ni jurídico de la propiedad, así como
                            tampoco podrá garantizar las visitas a los inmuebles y/o la falta de
                            visitas a los mismos, esto dependerá del comportamiento del mercado
                            actual, GUIA únicamente actúa como facilitador por medio de su
                            Plataforma.
                            <br /> <br />
                            El Propietario será el único y exclusivo responsable del contenido de
                            sus datos, de la información y estado del inmueble y de sus anuncios,
                            incluyendo, sin limitar, del monto y las condiciones de la renta o
                            precio de venta fijados, y será legalmente responsable de sus actos u
                            omisiones. GUIA no asumirá responsabilidad alguna por información de
                            carácter erróneo y/o las condiciones establecidas por el Propietario en
                            la Plataforma, GUIA únicamente hará sugerencias y cualquier decisión
                            final será del Propietario. GUIA ofrece los productos y/o servicios bajo
                            un nivel de competencia y uso razonable desde un punto de vista
                            comercial. GUIA no ofrece garantía alguna sobre su uso por lo que usted
                            conoce y acepta expresamente que el uso de este sitio web es bajo su
                            propio riesgo. GUIA no se hace responsable por errores en el llenado o
                            contenido introducido por usted mismo.
                            <br /> <br />
                            Todos los productos o servicios mostrados son más el impuesto al valor
                            agregado y los demás que pudieran corresponder de conformidad con la
                            legislación aplicable para territorio en los Estados Unidos Mexicanos.
                            Cualquier monto adicional al mostrado será indicado al usuario para su
                            toma de decisión de compra, de manera previa, y deberán ser aceptados y
                            pagados exclusivamente por el usuario.
                            <br /> <br />
                            GUIA se reserva el derecho a solicitar al usuario información adicional
                            antes, durante y después del pedido, cuando así sea requerido para el
                            correcto cumplimiento de las obligaciones adquiridas. Si por cualquier
                            motivo, el usuario encuentra un producto o servicio que se exprese en
                            precio $0.00 deberá entrar en contacto con el centro de atención al
                            cliente de GUIA, ya que en ninguna circunstancia se entenderá que un
                            producto o servicio del sitio web no tienen costo, son gratis o
                            regalados, salvo cuando así de manera clara y expresa se le indique al
                            usuario.
                            <br /> <br />
                            Todos los productos o servicios se encuentran sujetos a disponibilidad.
                            Si usted realiza un movimiento para generar una oferta, deberá usted
                            saber que no puede considerarlo hecho hasta en tanto no se le confirme
                            de manera clara y precisa por parte de GUIA. Si su oferta no pudiere
                            llevarse a cabo, se le notificará y cuando sea posible, se le informará
                            como subsanar los motivos para continuar con su proceso. El usuario
                            asume la responsabilidad de todos los gastos relacionados con costos,
                            tasas o impuestos que se deriven del uso de este sitio web.
                            <br /> <br />
                            GUIA ofrece una plataforma digital que funciona como intermediario entre
                            propietario y arrendatario de bienes raíces. GUIA no tiene
                            responsabilidad sobre las obligaciones legales generadas entre ambos
                            adquiridas por naturaleza de la figura jurídica de arrendamiento, o
                            cualquier otra aplicable.
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            5. PROPIEDAD INDUSTRIAL
                        </Heading>
                        <Text mb={8}>
                            Las marcas y/o avisos comerciales utilizados en el sitio web por parte
                            de GUIA son para uso exclusivo de su titular o licenciatario autorizado.
                            Queda prohibido el uso parcial o total, a través de cualquier medio, sin
                            autorización expresa por escrito de su titular. Las marcas, avisos
                            comerciales y cualquier figura de propiedad industrial se encuentran
                            protegidos por los distintos tratados internacionales, así como por la
                            Ley Federal de Protección a la Propiedad Industrial y su reglamento en
                            territorio mexicano.
                            <br />
                            <br />
                            <br />
                            Si usted considera que cualquier contenido publicado en el sitio web
                            viola o vulnera cualquiera de sus derechos de propiedad industrial,
                            podrá enviar su comentario directamente a GUIA a través de{" "}
                            <Link href="mailto:contactojuridico@grupoguia.mx">
                                contactojuridico@grupoguia.mx
                            </Link>
                            .
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            6. USUARIOS AUTORIZADOS
                        </Heading>
                        <Text mb={8}>
                            Usted, al crear una cuenta de usuario, conoce que la misma es personal,
                            única e intransferible. En caso de que GUIA identifique dos o más
                            cuentas de usuario con datos idénticos, coincidentes o relacionados,
                            podrá cancelarlos, suspenderlos o inhabilitarlos, a criterio exclusivo
                            de GUIA.
                            <br />
                            <br />
                            GUIA se reserva el derecho a rechazar una cuenta de usuario cuando no
                            cumpla con los requisitos establecidos en estos términos y condiciones.
                            GUIA no se encuentra obligado a emitir informe alguno con los motivos o
                            razones que dieron origen a la decisión, así como tampoco dará derecho a
                            indemnización al usuario.
                            <br />
                            <br />
                            Para el uso de este sitio, usted debe tener por lo menos 18 años
                            cumplidos. Usted al comprar o apartar en este sitio acepta que ha leído
                            y entendido esta información, y que se encuentra de acuerdo. En caso de
                            que un menor de edad desee comprar a través de este sitio web, podrá
                            hacerlo a través de sus padres o representantes, de conformidad con la
                            legislación aplicable.
                            <br />
                            <br />
                            Los padres, tutores o cualquier persona que actúe en representación
                            legal de una persona física o moral, será responsable directo de sus
                            actos según lo dispuestos en los presentes términos y condiciones, con
                            independencia de cualquier norma.
                            <br />
                            <br />
                            GUIA se reserva el derecho de restringir ciertas áreas de información de
                            este sitio a nuestros usuarios aprobados y registrados. En el evento de
                            que cualquier área de este sitio le solicite registrarse con nosotros de
                            manera previa para garantizar el acceso a un espacio determinado, usted
                            está de acuerdo que nos proveerá con información verídica y fidedigna,
                            incluyendo sin límite un nombre de usuario y contraseña, así como su
                            nombre, dirección, teléfono y una dirección de correo electrónica
                            válida. Usted acuerda proporcionarnos información verídica y actualizar
                            su cuenta en la forma necesaria. GUIA utilizará su información de
                            conformidad con el aviso de privacidad que puede usted consultar en
                            https://www.grupoguia.mx/aviso-privacidad Si usted tiene la sospecha o
                            confirma que su cuenta ha sido utilizada por un tercero, deberá dar
                            aviso de inmediato a GUIA a efecto de dar de baja su usuario de manera
                            inmediata. El usuario se obliga a indemnizar y sacar a salvo y en paz a
                            GUIA, sus subsidiarias, controladoras, accionistas, directivos,
                            empleados, funcionarios, consejeros, agente y cualquier persona que
                            pudiere estar relacionada de cualquier acción, reclamación,
                            procedimiento, demanda, responsabilidad, daños, perjuicios, gastos,
                            costas que se deriven o se encuentren relacionadas con la violación por
                            parte del usuario a los presentes términos y condiciones, así como a
                            cualquier legislación vigente.
                            <br />
                            <br />
                            GUIA se reserva el derecho a asumir de manera directa las acciones
                            relacionadas con la defensa y control de cualquier asunto que pudiera
                            implicar un pago asociado con el incumplimiento de un usuario. El
                            usuario cooperará en todo momento con GUIA proporcionando todo aquello
                            solicitado para la correcta defensa.
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            7. USO DE ESTE SITIO
                        </Heading>
                        <Text mb={8}>
                            GUIA le permite a usted de manera no limitada, no exclusiva y no
                            transferible, el acceso y licencia de uso de este sitio de conformidad
                            con los términos y condiciones que se muestran en este acuerdo. GUIA se
                            reserva cualquier derecho no expresado y que se encuentre protegido por
                            legislación aplicable. Cualquier uso de este sitio no específicamente
                            permitido por estos términos y condiciones se encuentra estrictamente
                            prohibido.
                            <br />
                            <br />
                            Usted acuerda que no puede: (i) utilizar este sitio para reproducir,
                            transmitir, almacenar o distribuir material legalmente protegido por
                            cualquier medio, vía o método sin la autorización por escrito de GUIA o
                            su titular (ii)copiar, editar, cambiar, preparar, almacenar cualquier
                            obra derivada o cualquier forma de alteración del contenido que se
                            provee en este sitio; o (iii) utilizar nuestro sitio en cualquier forma
                            que viole los términos de este acuerdo.
                            <br />
                            <br />
                            GUIA le concede al usuario una licencia de uso no transferible y
                            revocable para el uso del sitio web, en virtud de los presentes términos
                            y condiciones, con el propósito de rentar inmuebles comercializados en
                            la misma página.
                            <br />
                            <br />
                            Cualquier uso contrario a los términos y condiciones realizado por el
                            usuario dará lugar a la revocación inmediata de la licencia otorgada en
                            este apartado, sin previo aviso. Lo anterior con independencia de las
                            infracciones o acciones a que como consecuencia se diera a lugar.
                            <br />
                            <br />
                            El usuario es el único responsable del cuidado de sus contraseñas y
                            otros identificadores.
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            8. OTRAS RESTRICCIONES
                        </Heading>
                        <Text mb={8}>
                            Usted acuerda que no: (a) Utilizará este sitio para enviarnos
                            información personal distinta a la que sea solicitada por GUIA. (b) Se
                            abstendrá de utilizar un lenguaje que provoque agresión, racismo,
                            terrorismo, denigre en cualquier forma o violente los derechos humanos
                            de cualquier persona, en cuyo caso GUIA dará de baja su usuario de
                            manera automática y no le dará respuesta, con independencia a las
                            acciones legales a que se pueda hacer acreedor. (c) enviar por este
                            medio cadenas, información comercial, ofertas de negocios, portafolio de
                            servicios profesionales, información sobre seguros o negocios
                            piramidales o buscará atraer personas para actividades personales o
                            comerciales ajenas a GUIA, o (d) intentará obtener acceso denegado a
                            otro sistema o computadora a través de este sitio. Usted está de acuerdo
                            en que no utilizará este sitio de cualquier forma que pueda causar daño,
                            inhabilite o afecte en forma alguna el uso de un tercero a este sitio.
                            <br />
                            <br />
                            El acceso al contenido del sitio web puede no ser legal o cumplir con la
                            totalidad de requisitos legales para ciertas personas en determinados
                            países. GUIA no presume la legalidad, sino que el usuario es responsable
                            bajo su propio riesgo del uso de este sitio web fuera del territorio de
                            los Estados Unidos Mexicanos.
                            <br />
                            <br />
                            Queda estrictamente prohibido a los usuarios la violación o el intento
                            de violación a la seguridad de este sitio web y de los sitios web
                            afiliados de GUIA. Cualquier violación al sistema informático o la
                            seguridad de la red y/o los usuarios le pueden generar responsabilidad
                            de carácter civil, administrativo o penal, y en general a cualquier
                            legislación aplicable.
                            <br />
                            <br />
                            GUIA se deslinda de cualquier responsabilidad que pudiera provocar las
                            interrupciones o suspensiones del acceso a internet por cualquier falla
                            en el sistema de telecomunicaciones. De la misma forma, usted conoce que
                            GUIA no es responsable ante el daño, pérdida reparable o irreparable,
                            perjuicio y en general cualquier afectación que el usuario pueda tener
                            relacionados con fallas en el sistema, en el servidor o internet. GUIA
                            no es ni será responsable de cualquier virus o similar que pudiera ser
                            transferido al equipo del usuario por motivo del uso, acceso, descarga,
                            transferencia de cargas y en general por la interacción con el sitio
                            web.
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            9. ENVIOS DE CUALQUIER INFORMACIÓN
                        </Heading>
                        <Text mb={10}>
                            Si usted envía a GUIA un post en este sitio, testimonio, duda,
                            comentario, sugerencia o cualquier trabajo autoral incluyendo de manera
                            enunciativa más no limitativa, información sobre cualquiera de nuestros
                            productos o servicios, tome en cuenta que dicho envío no será
                            considerado información confidencial o secreto industrial y por lo tanto
                            no recibirá dicho tratamiento. Por favor no envíe cualquier comentario o
                            información que usted considera contiene información protegida por
                            alguna legislación en favor de un tercero o que usted desee mantener
                            confidencial por este medio, cuando no sea específicamente solicitada
                            por GUIA. Ninguna información o contenido que sea enviado por usted será
                            considerado o tratado como confidencial, excepto en los casos en que la
                            legislación así lo requiera a GUIA.
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            10. TÉRMINOS
                        </Heading>
                        <Text mb={10}>
                            Los términos aquí plasmados permanecerán efectivos hasta en tanto usted
                            termine su relación con nosotros o nosotros con usted.
                            <br />
                            <br />
                            Estos términos y condiciones son de vigencia ilimitada, entrando en
                            vigor al momento de su publicación en este sitio web y sustituyen
                            cualquier otro acuerdo o contrato celebrado con anterioridad, en todo
                            aquello que no contradiga a la legislación.
                            <br />
                            <br />
                            GUIA se reserva el derecho a cancelar en cualquier momento el sitio web
                            y/o terminar con los términos y condiciones presentes.
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            11. MODIFICACIONES AL SITIO WEB
                        </Heading>
                        <Text mb={10}>
                            GUIA tiene el derecho a modificar en cualquier momento, sin necesidad de
                            aviso al usuario, realizar correcciones o adiciones al contenido,
                            formato, presentación y en general a cualquier elemento del sitio web,
                            sin que esto otorgue derecho a ningún tipo de reclamación o
                            indemnización en favor del usuario.
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            12. CASO FORTUITO Y FUERZA MAYOR
                        </Heading>
                        <Text mb={12}>
                            GUIA no incurrirá en responsabilidad alguna o se considerará en
                            incumplimiento por cualquier retraso y/o incumplimiento de sus servicios
                            y/o de sus obligaciones bajo el presente y/o bajo cualquier contrato en
                            términos del presente debido a casos fortuitos o eventos de fuerza
                            mayor.
                            <br />
                            <br />
                            Caso fortuito o eventos de fuerza mayor se define como cualquier
                            circunstancia más allá del control razonable de GUIA o sus proveedores,
                            incluyendo pero no limitado a incendios, inundaciones, explosiones,
                            erupciones volcánicas, terremotos, huracanes, clima inusualmente grave,
                            disputas laborales o huelgas (ya sean legales o ilegales), revueltas,
                            insurrecciones, accidentes, escasez de materiales o mano de obra,
                            interrupciones en el internet o problemas de conexión, problemas de
                            transporte de cualquier tipo, lentitud en el trabajo, disturbio civil,
                            escasez de combustible, actos de la naturaleza, guerra (declarada o no
                            declarada), acuerdos, regulaciones, órdenes o requerimientos de
                            cualquier autoridad gubernamental o semi-gubernamental (ya sea que
                            dichos acuerdos, regulaciones, órdenes o requerimientos se declaren
                            inválidos), embargo, epidemia o pandemia de cualquier tipo (incluyendo
                            COVID-19), amenazas terroristas, ataques terroristas, ataques aéreos,
                            apagones, actos de enemigos públicos o cualquier otra circunstancia
                            ajeno al control de GUIA.
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="4"
                            color="accent.500"
                            fontWeight="400"
                            fontSize={{ md: "3xl", base: "xl" }}
                            textAlign="left"
                        >
                            13. GENERAL
                        </Heading>
                        <Box mb={8}>
                            <Text>
                                GUIA solamente ofrece servicios a través de este sitio y con
                                distribuidores autorizados. Usted puede contactarnos para
                                informarnos de cualquier producto o servicio que se ostente o
                                resulte similar en grado de confusión con cualquiera de nuestras
                                marcas o diseños por persona ajena a GUIA. Si usted sabe, o sospecha
                                de cualquier infracción que se cometa en contra de nuestros
                                productos y marcas, puede usted enviarnos un comunicado al domicilio
                                que se muestra en este sitio o bien, a nuestros teléfonos, de manera
                                anónima.
                                <br />
                                <br />
                                Estos términos y condiciones se interpretarán conforme a la
                                legislación aplicable de los Estados Unidos Mexicanos y de manera
                                estatal del Estado de Jalisco, renunciando a cualquier otra que por
                                razón de domicilio pudiera considerarse aplicable.
                                <br />
                                <br />
                                El usuario conoce su obligación de pago de daños y perjuicios en
                                favor de GUIA, sus afiliados, proveedores, accionistas,
                                funcionarios, empleados, asesores y en general cualquier persona
                                física o moral que por cualquier acción judicial o extrajudicial
                                derivada del incumplimiento del usuario al presente convenio, así
                                como al aviso de privacidad y en general la relación generada con
                                GUIA derivada de:
                            </Text>
                            <List.Root
                                pb="6"
                                px="4"
                                fontSize="sm"
                                mt="2"
                                variant="plain"
                                lineHeight="taller"
                            >
                                <List.Item>
                                    <List.Indicator color="brand.500" boxSize={5} mr={2} asChild>
                                        <CheckCircleIcon weight="fill" />
                                    </List.Indicator>
                                    El uso de este sitio web
                                </List.Item>
                                <List.Item>
                                    <List.Indicator color="brand.500" boxSize={5} mr={2} asChild>
                                        <CheckCircleIcon weight="fill" />
                                    </List.Indicator>
                                    Información contenida o disponible a través del sitio web que
                                    impliquen violación a los derechos de privacidad trasgrediendo
                                    los derechos al honor, la imagen, la vida privada y la
                                    autodeterminación informativa.
                                </List.Item>
                                <List.Item>
                                    <List.Indicator color="brand.500" boxSize={5} mr={2} asChild>
                                        <CheckCircleIcon weight="fill" />
                                    </List.Indicator>
                                    Amenazas, violencia, terrorismo, difamación o injurias a
                                    cualquier persona y en general información prohibida por la
                                    materia de derechos humanos, la Constitución Política de los
                                    Estados Unidos Mexicanos, los Tratados Internacionales de los
                                    que México forma parte y en general legislación aplicable en
                                    territorio mexicano.
                                </List.Item>
                            </List.Root>
                            El no ejercicio de alguna acción por parte de GUIA a alguna acción
                            legal, no implica la renuncia de ésta a aquella.
                            <br />
                            <br />
                            Para el supuesto en que cualquier letra, palabra, enunciado, línea o
                            párrafo establecida en los presentes términos y condiciones resultara
                            ilegal, nula, no aplicable o de imposible ejecución no implica la
                            invalidez o cancelación de todas las demás disposiciones de los términos
                            y condiciones, sino que solamente se tendrá por no puesto aquello que se
                            vea afectado prevaleciendo la validez y legitimidad en todo lo demás.
                            <br />
                            <br />
                            Los títulos o encabezados mostrados dentro de los presentes términos y
                            condiciones funcionan únicamente como referencia e identificación, por
                            lo que no deberán ser tomados como parte del texto para efectos de
                            interpretación jurídica.
                            <br />
                            <br />
                            Usted acepta que ha leído este acuerdo, lo entiende y acepta.
                        </Box>
                    </Box>
                </GridItem>
            </Grid>
            <Footer visible={false} />
        </Container>
    );
};

export default TerminosCondicionesGuiaRent;
